import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';
interface EmberCanvasProps {
  intensity: number;
}
interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  max: number;
  size: number;
}
export function EmberCanvas({
  intensity
}: EmberCanvasProps) {
  const ref = useRef<HTMLCanvasElement>(null);
  const intensityRef = useRef(intensity);
  const reduce = useReducedMotion();
  useEffect(() => {
    intensityRef.current = intensity;
  }, [intensity]);
  useEffect(() => {
    if (reduce) return;
    const canvas = ref.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;
    let w = 0;
    let h = 0;
    let raf = 0;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const particles: Particle[] = [];
    const resize = () => {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    const ro = new ResizeObserver(resize);
    ro.observe(canvas);
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      const spawn = intensityRef.current * 4;
      for (let i = 0; i < spawn; i++) {
        if (Math.random() < 0.5 || particles.length > 420) continue;
        particles.push({
          x: w * (0.3 + Math.random() * 0.7),
          y: h * (0.5 + Math.random() * 0.5),
          vx: (Math.random() - 0.5) * 0.8,
          vy: -(0.5 + Math.random() * 1.6),
          life: 0,
          max: 60 + Math.random() * 100,
          size: 0.6 + Math.random() * 1.8
        });
      }
      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.life += 1;
        p.x += p.vx + Math.sin((p.life + i) * 0.05) * 0.35;
        p.y += p.vy;
        p.vy *= 0.996;
        const t = p.life / p.max;
        if (t >= 1) {
          particles.splice(i, 1);
          continue;
        }
        ctx.fillStyle = `rgba(255, ${Math.round(110 + 100 * (1 - t))}, ${Math.round(50 * (1 - t))}, ${(1 - t) * 0.9})`;
        ctx.fillRect(p.x, p.y, p.size, p.size * 2.4);
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, [reduce]);
  return <canvas ref={ref} aria-hidden className="pointer-events-none absolute inset-0 h-full w-full mix-blend-screen" data-id="element-150" data-mp="17h0ki2r9t6lw" />;
}